import React, { PureComponent } from 'react'
import { Col, Container, Row, Progress } from 'reactstrap'
import showResults from './components/Show'
import Wizard from './components/WizardForm'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import '../../scss/component/assessments/assessment.scss';

class WizardForm extends PureComponent {
  componentWillMount () {
    return this.props.user ? null : this.props.history.push('/unauthorized')
  }

  render () {
    return (
      <Container>
        <Row>
          <Col md={12}>
            <h3 className='page-title'>{`${this.props.name ? this.props.name : null} Assessment`}</h3>
            <h3 className='page-subhead subhead'>Use this elements, if you want to show some hints or additional
              information</h3>
            <div className='project-summary__progress progress-wrap progress-wrap--big'>
              <Progress value={0}>0% Completed</Progress>
            </div>
          </Col>
        </Row>
        <Wizard onSubmit={showResults} />
      </Container>
    )
  }
}

function mapStateToProps (state) {
  return {
    user: state.auth.user
  }
}

export default connect(mapStateToProps)(withRouter(WizardForm))



// WEBPACK FOOTER //
// ./src/components/assessment/WizardForm.js